import { httpsCallable } from "firebase/functions";

import {
  demoAccount,
  demoAccountDirectory,
  demoCostLimitsData,
  demoDevices,
  demoOperations,
  demoOverview,
  demoUsage,
  demoWorkspace,
  demoWorkspaceDirectory,
  publishDemoCostLimits,
} from "../data/demo";
import { configuration } from "./configuration";
import { getAdminFunctions } from "./firebase";

import type { AdminReadRequest, AdminReadResponse, PublishCostLimitsRequest, PublishCostLimitsResponse } from "../types";

const demoRead = async (request: AdminReadRequest): Promise<AdminReadResponse> => {
  // Keep the preview useful while making it impossible to mistake sample values for live platform state.
  await new Promise((resolve) => window.setTimeout(resolve, 180));
  switch (request.view) {
    case "overview": return demoOverview();
    case "costLimits": return demoCostLimitsData();
    case "accountDirectory": return demoAccountDirectory(request.cursor);
    case "account": return demoAccount();
    case "workspaceDirectory": return demoWorkspaceDirectory(request.cursor);
    case "workspace": return demoWorkspace();
    case "devices": return demoDevices();
    case "usage": return demoUsage();
    case "operations": return demoOperations();
  }
};

export const publishCostLimits = async (request: PublishCostLimitsRequest): Promise<PublishCostLimitsResponse> => {
  if (configuration.mode === "demo") return publishDemoCostLimits(request);
  const callable = httpsCallable<PublishCostLimitsRequest, PublishCostLimitsResponse>(
    getAdminFunctions(),
    "publishTayanCostLimits",
  );
  return (await callable(request)).data;
};

export const readAdminData = async <T extends AdminReadResponse>(
  request: AdminReadRequest,
): Promise<T> => {
  if (configuration.mode === "demo") return demoRead(request) as Promise<T>;
  const callable = httpsCallable<AdminReadRequest, T>(getAdminFunctions(), "readTayanAdmin");
  const response = await callable(request);
  return response.data;
};
